import { render, staticRenderFns } from "./list.vue?vue&type=template&id=7fdd6f13&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=7fdd6f13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdd6f13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdd6f13')) {
      api.createRecord('7fdd6f13', component.options)
    } else {
      api.reload('7fdd6f13', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=7fdd6f13&scoped=true&", function () {
      api.rerender('7fdd6f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/specialty/list.vue"
export default component.exports